$(function($) {
    "use strict";
    $('[data-scroll]').on('click',
        function () {
            var id = $(this).data('href');
            var offset = $(this).data('scroll');
            if (/^#/.test(id)) {
                $.scrollTo(id, 1000, { offset: offset });
            }
        });
});